import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { LayoutModule } from "./layouts/layout.module";
import { CPipeModule } from "./pipes/c-pipe.module";
import { UiModule } from "./ui/ui.module";
import { AuthModule } from "./modules/auth/auth.module";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { EventService } from "./services/event.service";
import { HomeModule } from "./modules/home/home.module";
import { AppService } from "./services/app.service";
import { LocalStorageService } from "./services/local-storage.service";
import {
  declarationsThirdParties,
  exportSystemThirdParties,
  importSystemThirdParties,
  providersThirdParties,
} from "./config/third-party.config";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { CryptoService } from "./services/crypto.service";
import { CacheService } from "./services/cache.service";
import { PipeService } from "./services/pipe.service";
import { GlobalEventService } from "./services/global-event.service";
import { SocketService } from "./services/socket.service";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ...importSystemThirdParties,
    AuthModule,
    HomeModule,
    CPipeModule,
    UiModule,
    LayoutModule,
  ],
  exports: [...exportSystemThirdParties, CPipeModule, UiModule],
  providers: [
    ...providersThirdParties,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, // setup error handler
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, // setup auth handler
    { provide: EventService, useClass: GlobalEventService },
    AppService,
    LocalStorageService,
    CacheService,
    CryptoService,
    PipeService,
  ],
  entryComponents: [],
  declarations: [...declarationsThirdParties],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [AppService, LocalStorageService],
    };
  }
}
